var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWallTileDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#F5C58A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7872 25.2552C32.1303 25.4894 32.4964 25.7552 32.7717 25.9915C32.9232 26.1216 33 26.3147 33 26.5144C33 27.0574 32.4495 27.427 31.9469 27.2215L31.7478 27.1401C31.6386 27.0954 31.5218 27.0725 31.4039 27.0725L31.0384 27.0725C30.556 27.0725 30.1649 26.6814 30.1649 26.199C30.1649 26.0132 30.2242 25.8323 30.3341 25.6824L30.471 25.4959C30.7787 25.0764 31.3575 24.9619 31.7872 25.2552Z",
    fill: "#EDB26A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8646 27.8986L13.5706 27.4655C13.7285 27.3687 13.8247 27.1967 13.8247 27.0115C13.8247 26.8353 13.7376 26.6705 13.5921 26.5713L13.4656 26.4851C13.1724 26.2853 12.7839 26.2961 12.5023 26.5121L12.0921 26.8266C11.9333 26.9484 11.8402 27.1371 11.8402 27.3372C11.8402 27.5053 11.906 27.6668 12.0236 27.787L12.032 27.7956C12.2515 28.02 12.597 28.0627 12.8646 27.8986Z",
    fill: "#EDB26A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5355 31.881L23.7159 31.758C23.9742 31.5819 24.0107 31.2152 23.7921 30.9917C23.6976 30.895 23.5681 30.8406 23.433 30.8406L22.8132 30.8406C22.6195 30.8406 22.434 30.9186 22.2985 31.0571L22.1828 31.1755C22.0392 31.3222 22.0036 31.5435 22.0938 31.7279C22.1752 31.8944 22.3443 32 22.5297 32L23.1495 32C23.2872 32 23.4217 31.9585 23.5355 31.881Z",
    fill: "#EDB26A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5116 25.7535L22.5224 25.3742C22.158 25.2345 22.1007 24.743 22.4232 24.5232C22.4806 24.484 22.5458 24.4577 22.6143 24.446L24.0196 24.2066C24.146 24.185 24.2755 24.1903 24.3998 24.2221L24.7064 24.3005C25.0524 24.3889 25.2516 24.7513 25.1409 25.0908C25.0903 25.2461 24.9802 25.3751 24.8347 25.4495L24.3248 25.7101C24.0721 25.8393 23.7765 25.855 23.5116 25.7535Z",
    fill: "#EDB26A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5849 17.7289L25.6991 17.3892C25.3477 17.2545 25.3897 16.7445 25.7584 16.6692C25.8569 16.649 25.9433 16.5903 25.9982 16.506L26.1364 16.2942C26.3455 15.9735 26.7219 15.8035 27.1008 15.8589L28.3341 16.039C28.4183 16.0513 28.4962 16.0909 28.5557 16.1518C28.6706 16.2693 28.6992 16.4465 28.6269 16.5942L28.3965 17.0654C28.2602 17.344 28.0024 17.5436 27.6985 17.6058L26.9496 17.7589C26.8277 17.7839 26.7011 17.7734 26.5849 17.7289Z",
    fill: "#EDB26A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8672 20.7938L12.6625 20.6891C12.3112 20.5095 12.1929 20.0652 12.4084 19.7347C12.5125 19.575 12.6802 19.4677 12.8689 19.4402L14.4229 19.2132C14.5109 19.2004 14.6006 19.2086 14.6847 19.2373C15.0428 19.3593 15.1795 19.794 14.9557 20.099L14.7443 20.3872C14.6236 20.5518 14.4459 20.6656 14.2459 20.7065L13.4384 20.8716C13.2447 20.9112 13.0433 20.8838 12.8672 20.7938Z",
    fill: "#EDB26A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2978 13.4616L21.0456 13.2682C20.7523 13.0433 20.6817 12.6304 20.8836 12.3209C21.0141 12.1207 21.2369 12 21.4758 12L22.9912 12C23.2218 12 23.4368 12.1165 23.5627 12.3096C23.7656 12.6207 23.6823 13.0369 23.3755 13.2461L23.2221 13.3506C23.1265 13.4157 23.019 13.4612 22.9057 13.4844L22.1067 13.6477C21.8228 13.7058 21.5277 13.6379 21.2978 13.4616Z",
    fill: "#EDB26A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45L36 9H9L0 0Z",
    fill: "#FFE1BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45L-2.38419e-07 45L9 36L36 36L45 45Z",
    fill: "#402708"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 45L-1.31134e-06 0L9 9L9 36L0 45Z",
    fill: "#D6A972"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45 0L45 45L36 36L36 9L45 0Z",
    fill: "#7B4B0F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWallTileDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WallTileDefault.d84f6f34f3fa593efdeb2535e25f7756.svg";